import { jsx as _jsx } from "react/jsx-runtime";
import { Accordion as BootstrapAccordion } from 'react-bootstrap';
export const AccordionCollapse = props => (_jsx(BootstrapAccordion.Collapse, Object.assign({ eventKey: props.eventKey, id: props.id }, { children: props.children })));
